// extracted by mini-css-extract-plugin
module.exports = {"container":"MarketSwitch_container__1WMFN","disabled":"MarketSwitch_disabled__3wX_1"};